import React from 'react';
import {Form, Formik, Field} from 'formik';
import {Alert, Button, FormGroup, Input, Label} from 'reactstrap';

import {useUserDispatch, useUserState} from 'contexts/user';
import {submitForm} from 'utils/forms';
import track from 'utils/track';
import {useFetchUuid} from 'hooks/useFetchUuid';

import CustomRadioField from '../../../components/CustomRadioField';

const {SF_API_URL} = process.env;
const {SEGMENTATION_FORM_ID} = process.env;

export default function ({variant = null, onComplete = () => {}, ...props}) {
  const userDispatch = useUserDispatch();
  const {uuid, mcFormReqUUID, registrationId, email} = useUserState();
  const fetchUuid = useFetchUuid(SF_API_URL);
  return (
    <>
      <p className="text-center mb-0">One more question:</p>
      <div className="optin-wrap">
        <Formik
          initialValues={{
            bucket: null
          }}
          onSubmit={(values, actions) => {
            if (!values || !values.bucket) {
              return onComplete();
            }
            return submitForm(
              {uuid, registrationId, request_uuid: mcFormReqUUID, bucket: values.bucket},
              SEGMENTATION_FORM_ID
            )
              .then(({data}) => {
                userDispatch({type: 'UPDATE_USER', payload: {bucket: values.bucket}});
                if (email && !uuid) {
                  fetchUuid(email, data.proxy_data.mc_form_uuid)
                    .then((resolvedUuid) => {
                      if (resolvedUuid) userDispatch({type: 'UPDATE_USER', payload: {uuid: resolvedUuid}});
                    })
                    .catch((err) => console.error(err));
                }
              })
              .then(() =>
                track('User Segmented', {
                  uuid,
                  registrationId,
                  request_uuid: mcFormReqUUID,
                  bucket: values.bucket
                })
              )
              .then(() => onComplete())
              .catch((e) => {
                actions.setStatus({error: e});
                actions.setSubmitting(false);
              });
          }}
          render={({values, handleSubmit, isSubmitting, isValid, handleReset, status, ...props}) => (
            <Form onSubmit={handleSubmit}>
              {status && status.error && <Alert color="danger">{status.error}</Alert>}

              <FormGroup className="text-left mb-4" tag="fieldset" value={values.bucket}>
                <h4 className="text-center mt-3 mb-4">What’s your biggest reason for joining this Mini-Masterclass?</h4>
                <FormGroup className="form-check-radio" check>
                  <Label check>
                    <Field name="bucket" value="curious" component={CustomRadioField} /> To learn more about the
                    benefits of a plant-based diet
                  </Label>
                </FormGroup>
                <FormGroup className="form-check-radio" check>
                  <Label check>
                    <Field name="bucket" value="sustainability" component={CustomRadioField} /> Concern for animals or
                    our planet
                  </Label>
                </FormGroup>
                <FormGroup className="form-check-radio" check>
                  <Label check>
                    <Field name="bucket" value="health" component={CustomRadioField} /> A health concern for yourself or
                    a loved one
                  </Label>
                </FormGroup>
              </FormGroup>

              <Button
                className="text-uppercase text-h5 text-condensed text-800"
                color="cta"
                type="submit"
                disabled={isSubmitting}
                block
              >
                {isSubmitting ? 'Loading...' : <>Get Instant Access</>}
              </Button>
            </Form>
          )}
        />
      </div>
    </>
  );
}
